import React, { useRef } from "react";
import Icon from "../icons/Icon";
import { useThemeContext } from "../../providers/ThemeProvider";

const OPTIONS = [
  { value: "system", label: "Sistema", icon: "monitor" },
  { value: "light", label: "Claro", icon: "sun" },
  { value: "dark", label: "Escuro", icon: "moon" },
];

// Radiogroup com tabindex móvel, e não três botões soltos: o controle aparece
// no header de todas as telas, e três paradas de Tab seriam cobradas em cada
// percurso de teclado do produto inteiro.
function ThemeToggle() {
  const { preference, setPreference } = useThemeContext();
  const optionRefs = useRef([]);

  const selectByOffset = (offset) => {
    const current = OPTIONS.findIndex((option) => option.value === preference);
    const next = (current + offset + OPTIONS.length) % OPTIONS.length;

    setPreference(OPTIONS[next].value);
    optionRefs.current[next]?.focus();
  };

  const handleKeyDown = (event) => {
    const offset = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
    if (!offset) return;

    event.preventDefault();
    selectByOffset(offset);
  };

  return (
    <div className="theme-switch" role="radiogroup" aria-label="Tema" onKeyDown={handleKeyDown}>
      {OPTIONS.map((option, index) => (
        <button
          key={option.value}
          ref={(node) => {
            optionRefs.current[index] = node;
          }}
          type="button"
          role="radio"
          className="theme-switch-option"
          aria-checked={preference === option.value}
          aria-label={option.label}
          tabIndex={preference === option.value ? 0 : -1}
          onClick={() => setPreference(option.value)}
        >
          <Icon name={option.icon} size={16} />
        </button>
      ))}
    </div>
  );
}

export default ThemeToggle;
